import { isSampleOrderShop } from 'commons/sampleOrder/sampleOrderShops';
import { i18n } from 'commons/translate/i18n';

const { t } = i18n.global;

type PointOfSaleKey =
  | 'OWN_SHOP'
  | 'FOREIGN_SHOP'
  | 'CYO'
  | 'MP'
  | 'EMP'
  | 'UNKNOWN';

type PointOfSale = {
  key: PointOfSaleKey;
  name: string;
  showDesign?: boolean;
  logo: string;
};

export const POINTS_OF_SALE: Record<PointOfSaleKey, PointOfSale> = {
  OWN_SHOP: {
    key: 'OWN_SHOP',
    name: 'GENERAL.SHOP',
    logo: 'shop',
  },
  FOREIGN_SHOP: {
    key: 'FOREIGN_SHOP',
    name: 'GENERAL.FOREIGN_SHOP',
    showDesign: true,
    logo: 'shop',
  },
  CYO: {
    key: 'CYO',
    name: 'GENERAL.CYO',
    showDesign: true,
    logo: 'mp',
  },
  MP: {
    key: 'MP',
    name: 'GENERAL.MARKETPLACE',
    logo: 'mp',
  },
  EMP: {
    key: 'EMP',
    name: 'GENERAL.EXTERNAL_MARKETPLACE',
    logo: 'mp',
  },
  UNKNOWN: {
    key: 'UNKNOWN',
    name: '',
    showDesign: true,
    logo: 'mp',
  },
};

export function pointsOfSaleConfig(pos?: string) {
  return (
    (pos && POINTS_OF_SALE[pos as PointOfSaleKey]) || POINTS_OF_SALE.UNKNOWN
  );
}

export function pointOfSaleName(posObject: {
  pos?: string;
  pointOfSale?: string;
  shopName?: string;
  shopId?: string | number;
}) {
  const pos = posObject.pos || posObject.pointOfSale;
  if (pos === POINTS_OF_SALE.OWN_SHOP.key) {
    return posObject.shopName || posObject.shopId;
  }

  if (pos === POINTS_OF_SALE.FOREIGN_SHOP.key) {
    // A partner's own sample order is booked in a BU-owned sample shop. Showing that shop as
    // "Other Partner's Shop" would suggest a stranger sold the design.
    if (isSampleOrderShop(posObject.shopId)) {
      return t('GENERAL.SAMPLE_ORDER');
    }

    return `${t(POINTS_OF_SALE.FOREIGN_SHOP.name)}: ${
      posObject.shopName || posObject.shopId
    }`;
  }

  return t(pointsOfSaleConfig(pos).name);
}

export const REJECTION_REASONS = {
  EMBROIDERY: 'DESIGNS.STATUS.REJECTION_REASONS.EMBROIDERY',
  COPYRIGHT: 'DESIGNS.STATUS.REJECTION_REASONS.COPYRIGHT',
  UNKNOWN_RIGHT_OF_USE: 'DESIGNS.STATUS.REJECTION_REASONS.UNKNOWN_RIGHT_OF_USE',
  COMMUNITY_GUIDELINES: 'DESIGNS.STATUS.REJECTION_REASONS.COMMUNITY_GUIDELINES',
  MP_GUIDELINES: 'DESIGNS.STATUS.REJECTION_REASONS.MP_GUIDELINES',
  QUALITY: 'DESIGNS.STATUS.REJECTION_REASONS.QUALITY',
  MP_NON_PERFORMING_REMOVAL:
    'DESIGNS.STATUS.REJECTION_REASONS.MP_NON_PERFORMING_REMOVAL',
  OTHER: 'DESIGNS.STATUS.REJECTION_REASONS.OTHER',
} as const;

export function rejectionReasonName(key: string) {
  return (
    REJECTION_REASONS[key as keyof typeof REJECTION_REASONS] ||
    REJECTION_REASONS['OTHER']
  );
}
